import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
  response: false,
};

const reactivateTeamMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REACTIVATE_TEAM_MEMBER_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.REACTIVATE_TEAM_MEMBER_REQUESTED_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        response: action.payload,
      };
    case types.REACTIVATE_TEAM_MEMBER_REQUESTED_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
        response: [],
      };
    default:
      return state;
  }
};
export default reactivateTeamMembersReducer;
